import {
  FiBarChart2,
  FiBookOpen,
  FiCalendar,
  FiDatabase,
  FiFileText,
  FiFolder,
  FiHome,
  FiSettings,
  FiTrello,
  FiTrendingUp,
  FiUser,
  FiUsers,
  FiZap,
} from 'react-icons/fi';
import { ILinkItemProps } from '../SidebarItem';

export const AdminSidebarLinkItems: Array<ILinkItemProps> = [
  { name: 'Home', icon: FiHome, link: '/admin' },
  { name: 'Semester', icon: FiCalendar, link: '/admin/semesters' },
  { name: 'Class', icon: FiTrello, link: '/admin/class' },
  { name: 'Teacher', icon: FiUser, link: '/admin/teacher' },
  { name: 'Student', icon: FiUsers, link: '/admin/student' },
  { name: 'Library', icon: FiBookOpen, link: '/admin/library' },
  { name: 'Leaderboard', icon: FiBarChart2, link: '/admin/leaderboard' },
  { name: 'Analytics', icon: FiTrendingUp, link: '/admin/analytics' },
  { name: 'Evaluation', icon: FiSettings, link: '/admin/tools' },
  // { name: 'Create', icon: FiPlus, link: '/admin/create' },
  { name: 'Create AI Log', icon: FiFileText, link: '/admin/report' },
  { name: 'AI Log', icon: FiZap, link: '/admin/ai-test' },
  { name: 'System Log', icon: FiFolder, link: '/admin/log' },
  { name: 'Vocabulary', icon: FiDatabase, link: '/admin/vocabulary' },
];
